/**
 * ArrayUtil.ts
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set}
 */
export class ArrayUtil {
    static groupBy(sourceArray, callback) {
        return sourceArray.slice().reduce((prev, next) => {
            let group = callback(next);
            prev[group] = prev[group] || [];
            prev[group].push(next);
            return prev;
        }, {});
    }
    static pivot(columnArray) {
        let rowArray = [];
        for (let row = 0; row < columnArray[0].length; row++) {
            rowArray = rowArray.concat(columnArray.map((column) => column[row]));
        }
        return rowArray;
    }
    /**
     * Asserts that `a` and `b` have equal elements in the same order.
     */
    static equals(a, b) {
        if (Array.isArray(a) && Array.isArray(b)) {
            return (a.length === b.length &&
                a.every((elem, index) => this.elemEquals(elem, b[index])));
        }
        return a === b;
    }
    /**
     * You probably meant to use ArrayUtil.equals.
     */
    static elemEquals(a, b) {
        if (typeof a === "object" && a.equals) {
            return typeof b === "object" && a.equals(b);
        }
        return a === b;
    }
    /**
     * @returns A random element from `sourceArray`.
     */
    static pick(sourceArray) {
        return sourceArray[Math.floor(Math.random() * sourceArray.length)];
    }
    /**
     * Safely combine two arrays.
     */
    static concat(arr1, arr2) {
        return arr1 && arr2 ? [...arr1, ...arr2] : arr1 || arr2;
    }
    /**
     * @returns A new array of items in `sourceArray` but not in elementsToRemove.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set/difference}
     */
    static removeMatchingElements(originalArray, elementsToRemove) {
        return originalArray.filter((element) => !elementsToRemove.includes(element));
    }
    /**
     * Fisher-Yates shuffle.
     * @param array - To be shuffled.
     * @param inPlace - Modify the original `array`. Default false.
     * @returns The shuffled array, if inPlace is true then it is the same reference as `array`.
     * @see {@link https://en.wikipedia.org/wiki/Fisher-Yates_shuffle#The_modern_algorithm}
     */
    static shuffle(array, inPlace = false) {
        let ret = inPlace ? array : array.slice();
        for (let i = ret.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [ret[i], ret[j]] = [ret[j], ret[i]];
        }
        return ret;
    }
}
//# sourceMappingURL=ArrayUtil.js.map